<template>
  <span class="nd-underline" :style="{width: `${width}rem`, height: `${height}rem`}"></span>
</template>

<script>
export default {
  name: 'nd-underline',
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: false
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/mixin.less";

    .nd-underline {
        height: 28px;
        margin-left: 1px;
        margin-right: 1px;
        top: 5px;
        border-bottom: 1px #000000 solid;
        display: inline-block;
        position: relative;
    }
</style>
